module.exports = __webpack_public_path__ + "ea878c407ff2663ed978ced205e55b69.MP3";